export default __webpack_public_path__ + "static/media/mo.d153de21.jpg";